<template>
	<el-dialog
		v-loading="areaLoading"
		title="素材库"
		:visible.sync="visible"
		width="680px"
		custom-class="materialLibrary"
		@closed="closed"
	>
		<!-- <tab :tab-map="tabMap" :tab-key.sync="tabKey" /> -->
		<div class="contentBox">
			<self
				ref="material0"
				:class="{ showitem: tabKey == 0 }"
				:type="type"
				:get-params="getParams"
				:use-params="useParams"
				:use-payload="usePayload"
				:multiple="multiple"
				:max-len="maxLen"
				@choose="chooseMaterila"
			/>
			<!-- <system ref="material1" :class="{ showitem: tabKey == 1 }" :type="type" @choose="chooseMaterila" /> -->
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="hide"> 取 消 </el-button>
			<el-button type="primary" @click="enter"> 确 定 </el-button>
		</div>
	</el-dialog>
</template>

<script>
// import tab from './tab';
import self from './self';
// import system from './system';
import { errors } from '../../services/http';
export default {
	components: {
		// tab,
		self,
		// system,
	},
	data() {
		return {
			visible: false,
			sync: true,
			tabKey: 0,
			reslove: null,
			reject: null,
			resloved: false,
			areaLoading: false,
		};
	},
	computed: {
		tabMap() {
			return {
				0: '个人素材',
				1: '平台素材',
				// 3: '媒体库',
			};
		},
	},
	methods: {
		show(reslove, reject) {
			this.reslove = reslove;
			this.reject = reject;
			this.visible = true;
		},
		hide() {
			this.visible = false;
		},
		async enter() {
			try {
				this.areaLoading = true;
				const result = await this.$refs[`material${this.tabKey}`].use();
				if (result) {
					this.reslove(result);
					this.resloved = true;
					this.hide();
				}
				this.areaLoading = false;
			} catch (err) {
				this.areaLoading = false;
				errors(err);
			}
		},
		closed() {
			if (!this.resloved) {
				this.reject('not choose');
			}
			this.$destroy(true);
			this.$el.parentNode.removeChild(this.$el);
		},
		chooseMaterila(item) {
			this.reslove(item);
			this.resloved = true;
			this.hide();
		},
	},
};
</script>

<style lang="less">
.materialLibrary {
	.el-dialog__header {
		padding: 20px 40px;
		border-bottom: 1px solid #d9dbe0;
		.el-dialog__headerbtn {
			right: 30px;
		}
		.el-icon-close {
			font-size: 24px;
		}
	}
	.el-dialog__body {
		padding: 0;
	}
	.contentBox {
		height: 462px;
		position: relative;
		margin-top: 20px;
	}
	.showitem {
		z-index: 10;
	}
	.materialCheck {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: #fff;
	}
	.searchBar {
		display: flex;
		justify-content: space-between;
		padding: 0 40px;
		& > div {
			display: flex;
			align-items: center;
		}
		.label {
			white-space: nowrap;
			font-size: 16px;
			color: #000000;
		}
		.label2 {
			font-size: 16px;
			color: #677381;
			margin-right: 10px;
		}
		.el-input {
			width: 210px;
			margin-left: 10px;
		}
		.el-input__inner {
			border-radius: 2px;
			border: 1px solid #dbdfe3;
			height: 40px;
		}
		.el-button--primary {
			display: block;
			width: 110px;
			height: 40px;
			margin-left: 20px;
			border-radius: 2px;
			background-color: #477df2;
			color: #fff;
			border-color: #477df2;
		}
	}
	.content {
		margin-top: 20px;
		height: 382px;
		background-color: rgba(71, 125, 242, 0.1);
		overflow: auto;
		display: flex;
		align-content: flex-start;
		flex-wrap: wrap;
		padding: 0 40px 20px;
		user-select: none;
		.material-item {
			margin-top: 20px;
			width: 108px;
			margin-right: 50px;
			&:nth-of-type(4n) {
				margin-right: 0;
			}
			.material-item-name {
				font-size: 16px;
				line-height: 22px;
				color: #000000;
				text-align: center;
				margin-top: 10px;
				display: flex;
				justify-content: center;
				span {
					padding: 0 6px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					text-overflow: ellipsis;
					transition: 0.3s;
				}
			}
		}

		.material-item1 {
			height: 162px;
			cursor: pointer;
		}
		.material-item3 {
			height: 126px;
			cursor: pointer;
		}
		.material-item2 {
			height: 115px;
			cursor: pointer;
		}
		.material-image {
			width: 108px;
			.material-image-box {
				height: 108px;
				display: flex;
				justify-content: center;
				align-items: center;
				background-color: rgba(71, 125, 242, 0.1);
				border-radius: 6px;
				position: relative;
				transition: 0.3s;
				img {
					max-width: 108px;
					max-height: 108px;
				}
			}
			.material-item-name {
				margin-top: 12px;
			}
		}
		.material-doc {
			width: 108px;
			.material-doc-box {
				width: 74px;
				height: 72px;
				margin: 0 auto;
				display: flex;
				justify-content: center;
				align-items: center;
				box-sizing: border-box;
				.icon {
					width: 50px;
					height: 50px;
				}
			}
		}
		.material-video {
			width: 108px;
			position: relative;
			.material-video-box {
				height: 61px;
				background-position: center center;
				background-size: cover;
				object-fit: cover;
				display: flex;
				justify-content: center;
				align-items: center;
				.iconfont {
					color: #fff;
					font-size: 30px;
				}
			}
		}
		p {
			width: 100%;
			text-align: center;
			margin-top: 10px;
		}
		.material-item.active {
			.material-image-box {
				&:before {
					content: '';
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					width: 118px;
					height: 118px;
					background: rgba(0, 0, 0, 0.03);
					border-radius: 4px;
					border: 1px solid #d9d9d9;
				}
			}
			.material-video-box {
				&:before {
					content: '';
					position: absolute;
					width: 118px;
					height: 71px;
					background: rgba(0, 0, 0, 0.03);
					border-radius: 4px;
					border: 1px solid #d9d9d9;
				}
			}
			.material-doc-box {
				background: rgba(0, 0, 0, 0.03);
				border-radius: 3px;
				border: 1px solid #d8dce1;
			}
			.material-item-name {
				span {
					background: #477df2;
					border-radius: 4px;
					color: #fff;
				}
			}
		}
	}
	.noContent {
		height: 382px;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		img {
			display: block;
			width: 160px;
		}
		div {
			font-size: 16px;
			color: #989ba6;
			line-height: 22px;
			margin-top: 15px;
			text-align: center;
		}
	}
	.el-dialog__footer {
		height: 80px;
		padding: 0;
		.dialog-footer {
			height: 80px;
			display: flex;
			justify-content: center;
			align-items: center;
			.el-button + .el-button {
				margin-left: 120px;
			}
			.el-button {
				width: 110px;
				height: 40px;
				border-radius: 2px;
			}
			.el-button--default {
				background-color: #b5b5b5;
				color: #fff;
				border-color: #b5b5b5;
				// &:hover {
				// 	background-color: #B5B5B5;
				// }
			}
			.el-button--primary {
				background-color: #477df2;
				color: #fff;
				border-color: #477df2;
			}
		}
	}
}
</style>
